module.exports = __webpack_public_path__ + "e4a9a6ab375bebaa87b01d4adc2b7868.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/new-design/icons/googlepay.svg
// module id = 1274
// module chunks = 73